module.exports = __webpack_public_path__ + "img/prizesTab2.c9dbde2e.png";